import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../Header';
import HelpModal from '../HelpModal';
import { ReactComponent as ConstructionImage } from 'assets/images/Construction.svg';

import { CONTACT_US_URL, PRIVACY_POLICY_URL } from 'constants/common';
import { useStyles } from './styles';

interface IWithBrandingProps {
  Content: React.ReactNode;
  hasLoginButton?: boolean;
  contentContainerStyleClass?: string;
  showOnlineWarning?: boolean;
}

const WithBranding: React.FC<IWithBrandingProps> = ({
  Content,
  hasLoginButton,
  contentContainerStyleClass,
  showOnlineWarning,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);

  return (
    <div className={classes.container}>
      <div className={`${classes.sidebar} ${classes.sidebarHidden}`}>
        <div className={classes.sideBarTopParent}>
          {/* Logo lives in the full-width Header now (not on the navy panel). */}
          <div className={classes.sidebarTextParent}>
            <p className={classes.sidebarTitle}>{t('selectProject.welcome')}</p>
            <p className={classes.sidebarSubtitle}>{t('selectProject.fca')}</p>
          </div>
        </div>
        <div className={classes.sideBarBottomParent}>
          <div className={classes.sidebarImageParent}>
            <ConstructionImage className={classes.sidebarImage} />
          </div>
          <div className={classes.sidebarActions}>
            <button className={classes.actionItem} onClick={() => setIsHelpModalVisible(true)}>
              {t('common.help')}
            </button>
            <a className={classes.actionItem} href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
              {t('common.privacyPolicy')}
            </a>
            <a className={classes.actionItem} href={CONTACT_US_URL} target="_blank" rel="noopener noreferrer">
              {t('common.contactUs')}
            </a>
          </div>
        </div>
      </div>
      <div
        className={`${classes.contentContainer} ${showOnlineWarning ? classes.contentContainerWithWarning : ''} ${contentContainerStyleClass || ''}`}
      >
        <Header
          hasLoginButton={hasLoginButton}
          styleClass={classes.headerFloating}
          showOnlineWarning={showOnlineWarning}
          fullWidthHeader={true}
        />
        <div className={classes.content}>
          <div className={`${classes.sideBarTopParent} ${classes.sideBarTopParentHidden}`}>
            {/* Logo lives in the full-width Header now (not on the navy panel). */}
            <div className={classes.sidebarTextParent}>
              <p className={classes.sidebarTitle}>{t('selectProject.welcome')}</p>
              <p className={classes.sidebarSubtitle}>{t('selectProject.fca')}</p>
            </div>
          </div>
          <div className={classes.card}>{Content}</div>
          <div className={classes.mobileSidebarActions}>
            <button className={classes.mobileActionItem} onClick={() => setIsHelpModalVisible(true)}>
              {t('common.help')}
            </button>
            <a className={classes.mobileActionItem} href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
              {t('common.privacyPolicy')}
            </a>
            <a className={classes.mobileActionItem} href={CONTACT_US_URL} target="_blank" rel="noopener noreferrer">
              {t('common.contactUs')}
            </a>
          </div>
        </div>
      </div>
      <HelpModal isVisible={isHelpModalVisible} onClose={() => setIsHelpModalVisible(false)} />
    </div>
  );
};

export default memo(WithBranding);
